/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'plan-starter-portfolio-48x48': {
    width: 48,
    height: 48,
    viewBox: '0 0 48 48',
    data: '<g _stroke="#22262A" stroke-width="2" _fill="none" fill-rule="evenodd"><circle pid="0" cx="24" cy="24" r="23"/><path pid="1" stroke-linecap="round" stroke-linejoin="round" d="M24 13.5v9M19 16.516c-.491.328-.948.704-1.364 1.12A9 9 0 1029 16.516"/></g>'
  }
})
